import React from 'react';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { Router } from 'pages/Router';

import appStore from 'domain/store/app.store';

import './App.scss';

const App = () => {
  return (
    <Provider store={appStore}>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </Provider>
  );
};

export default App;
